import {
  AnalyticsArgs,
  AnalyticsCampaign,
  ApiReturn,
  Campaign,
  CampaignBrand,
  CampaignProduct,
  ServiceState,
} from "../../types";
import API from "./../index";
import {
  PARTNER_DPC_OVERVIEW_LIST,
  PARTNER_CAMPAIGNS_FOR_ANALYTICS,
  PARTNER_CAMPAIGN_PRODUCTS,
  PARTNER_CAMPAIGN_BRANDS,
  PARTNER_COUNTRIES,
  PARTNER_FILTER_ANALYTICS,
  GET_SERVICE_STATUSSES,
  GET_PARTNER_TEMPLATES,
  UPDATE_PARTNER_TEMPLATES,
  GET_CONTACT_SETTINGS,
  SAVE_CONTACT_SETTINGS,
} from "./partner.endpoint";

export const fetchDpcOverview = (partnerId: string) => {
  return new Promise((resolve, reject) => {
    API.get(
      PARTNER_DPC_OVERVIEW_LIST.replace(":partnerId", partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchCampaignsForAnalytics = (
  partnerId?: string
): Promise<ApiReturn<Campaign[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      PARTNER_CAMPAIGNS_FOR_ANALYTICS.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchPartnerCampaignProducts = (
  partnerId?: string
): Promise<ApiReturn<CampaignProduct[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      PARTNER_CAMPAIGN_PRODUCTS.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchPartnerCampaignBrands = (
  partnerId?: string
): Promise<ApiReturn<CampaignBrand[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      PARTNER_CAMPAIGN_BRANDS.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchPartnerCountries = (
  partnerId?: string
): Promise<ApiReturn<CampaignBrand[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      PARTNER_COUNTRIES.replace(":partnerId", partnerId!),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const filterAnalytics = (
  data: AnalyticsArgs
): Promise<ApiReturn<AnalyticsCampaign[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      PARTNER_FILTER_ANALYTICS,
      { ...data },
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchServiceStatusses = (
  serviceId: string
): Promise<ApiReturn<ServiceState[]> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_SERVICE_STATUSSES.replace(":serviceId", serviceId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const fetchServiceTemplates = (
  partnerId: string
): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_PARTNER_TEMPLATES.replace(":partnerId", partnerId),
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

export const updateServiceTemplates = (
  partnerId: string,
  templates: any
): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      UPDATE_PARTNER_TEMPLATES.replace(":partnerId", partnerId),
      templates,
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
};





export const fetchContactSettings = (partnerId: string): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.get(
      GET_CONTACT_SETTINGS.replace(":partnerId", partnerId),
      (res: any) => resolve(res),
      (err: any) => reject(err)
    );
  });
};

export const saveContactSettings = (partnerId: string, settings: any): Promise<ApiReturn<any> | ApiReturn> => {
  return new Promise((resolve, reject) => {
    API.post(
      SAVE_CONTACT_SETTINGS.replace(":partnerId", partnerId),
      settings,
      (res: any) => resolve(res),
      (err: any) => reject(err)
    );
  });
};
